import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Toolbar.css';
import ThemeSwitcher from './ThemeSwitcher';
import { FaBars } from 'react-icons/fa';
import { Drawer, Button } from 'antd';

const Toolbar = ({ isDarkMode, toggleTheme }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const isDocsPage = location.pathname.includes('/docs');

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      setIsScrolled(position > 50);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId, closeDrawer = false) => {
    if (closeDrawer) {
      setIsDrawerVisible(false);
    }

    if (isHomePage) {
      // If already on home page, scroll to the section
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If not on home page, navigate to home and then scroll to section
      navigate('/', { state: { scrollToId: sectionId } });
    }
  };

  useEffect(() => {
    // Check if we've navigated to home with a section to scroll to
    if (isHomePage && location.state?.scrollToId) {
      const sectionId = location.state.scrollToId;
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [isHomePage, location.state]);

  const showDrawer = () => setIsDrawerVisible(true);
  const onCloseDrawer = () => setIsDrawerVisible(false);

  const macDownloadUrl = "https://d2ruaev2blr0t3.cloudfront.net/RepoPrompt.dmg";
  const discordInviteUrl = "https://discord.gg/NtbFDAJPGM";

  return (
    <>
      <nav className={`toolbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="toolbar-content">
          <Button
            type="text"
            className="hamburger-button"
            onClick={showDrawer}
            icon={<FaBars size={24} />}
            aria-label="Open navigation menu"
          />

          <div className={`logo-title ${isScrolled || isDocsPage ? 'scrolled' : ''}`}>
            <img src="/images/RepoPromptLogo_NoBG.png" alt="Repo Prompt Logo" className="logo" />
            <h1 className="title">Repo Prompt</h1>
          </div>

          <div className="nav-items-container">
            <ul className="nav-items">
              <li><button className="nav-button" onClick={() => scrollToSection('hero')}>Home</button></li>
              <li><button className="nav-button" onClick={() => scrollToSection('features')}>Features</button></li>
              <li><button className="nav-button" onClick={() => scrollToSection('pricing')}>Pricing</button></li>
              <li><Link to="/docs" className="nav-link">Docs</Link></li>
            </ul>
          </div>

          <div className="action-buttons">
            <a href={macDownloadUrl} target="_blank" rel="noopener noreferrer" className="action-button">Download</a>
            <a href={discordInviteUrl} target="_blank" rel="noopener noreferrer" className="action-button">Discord</a>
            <ThemeSwitcher isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
          </div>
        </div>
      </nav>

      <Drawer
        title="Menu"
        placement="left"
        onClose={onCloseDrawer}
        open={isDrawerVisible}
        bodyStyle={{ padding: '1rem' }}
      >
        <ul className="drawer-nav-items">
          <li><button className="drawer-nav-button" onClick={() => scrollToSection('hero', true)}>Home</button></li>
          <li><button className="drawer-nav-button" onClick={() => scrollToSection('features', true)}>Features</button></li>
          <li><button className="drawer-nav-button" onClick={() => scrollToSection('pricing', true)}>Pricing</button></li>
          <li><Link to="/docs" onClick={onCloseDrawer} className="drawer-nav-link">Docs</Link></li>
          <li><a href={macDownloadUrl} target="_blank" rel="noopener noreferrer" onClick={onCloseDrawer} className="drawer-nav-link">Download</a></li>
          <li><a href="https://forms.gle/TGx1ZuT3oqng7EuKA" target="_blank" rel="noopener noreferrer" onClick={onCloseDrawer} className="drawer-nav-link">Windows/Linux Waitlist</a></li>
          <li><a href={discordInviteUrl} target="_blank" rel="noopener noreferrer" onClick={onCloseDrawer} className="drawer-nav-link">Discord</a></li>
          <li><hr style={{ margin: '10px 0', opacity: 0.2 }} /></li>
          <li><a href="mailto:contact@repoprompt.com" onClick={onCloseDrawer} className="drawer-nav-link">Contact</a></li>
          <li><a href="/privacy" onClick={onCloseDrawer} className="drawer-nav-link">Privacy Policy</a></li>
          <li><a href="/terms" onClick={onCloseDrawer} className="drawer-nav-link">Terms & Conditions</a></li>
          <li><a href="https://polar.sh/repo-prompt/portal/request" target="_blank" rel="noopener noreferrer" onClick={onCloseDrawer} className="drawer-nav-link">Customer Portal</a></li>
        </ul>
      </Drawer>
    </>
  );
};

export default Toolbar;